import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { COMPARE, IMAGES } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
function Cell({
  value
}: {
  value: boolean | 'varies';
}) {
  if (value === 'varies') {
    return <span className="text-xs font-medium text-forest/50" data-id="element-43" data-mp="3ii7fxkrsfbe4">Varies</span>;
  }
  return value ? <span className="flex h-6 w-6 items-center justify-center rounded-full bg-forest text-ivory" data-id="element-44" data-mp="3nfpqfflgdyo8">
      <CheckIcon className="h-3.5 w-3.5" data-id="element-45" data-mp="38iyoaykea8ux" />
    </span> : <span className="flex h-6 w-6 items-center justify-center rounded-full bg-forest/8 text-forest/40" data-id="element-46" data-mp="3djmp2byfe42c">
      <XIcon className="h-3.5 w-3.5" data-id="element-47" data-mp="2zkd6j5mqyxv7" />
    </span>;
}
export function Compare() {
  return <Section className="py-16 md:py-20" data-id="element-48" data-mp="34hwoafinlsrw">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-49" data-mp="34iyang54e1ox">
        <Eyebrow data-id="element-50" data-mp="xryv8pepkrnr">Compare Medufit</Eyebrow>
        <h2 className="mt-4 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl lg:text-[2.75rem]" data-id="element-51" data-mp="xt0911n3zs96">
          One sachet vs. a shelf of supplements
        </h2>
      </Reveal>

      <div className="mx-auto mt-10 grid max-w-6xl items-stretch gap-6 lg:grid-cols-[0.82fr_1.18fr]" data-id="element-52" data-mp="23qm8xcufppvo">
        <Reveal className="hidden lg:block" data-id="element-53" data-mp="1zqlkr0hja0bf">
          <div className="relative h-full min-h-[430px] overflow-hidden rounded-[2rem] bg-forest-deep shadow-[0_24px_60px_rgba(6,46,36,0.2)]" data-id="element-54" data-mp="2dirvu85txh40">
            <img src={IMAGES.compare} alt="Medufit daily nutrition box and single sachet" className="absolute inset-0 h-full w-full object-cover" data-id="element-55" data-mp="28jxhbiewaepp" />
            <div className="absolute inset-x-5 bottom-5 rounded-2xl border border-ivory/15 bg-forest-deep/90 p-5 text-ivory backdrop-blur-sm" data-id="element-56" data-mp="1gtsoqwgzelde">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage" data-id="element-57" data-mp="1psxp88c3sos7">The simpler choice</p>
              <p className="mt-2 font-serif text-2xl leading-tight" data-id="element-58" data-mp="3664l4q3dk310">Complete nutrition, beautifully uncomplicated.</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="overflow-hidden rounded-[1.75rem] border border-forest/12 bg-white/55 shadow-[0_16px_45px_rgba(6,46,36,0.06)]" data-id="element-59" data-mp="31a77irjhxarx">
          <div className="grid grid-cols-[1.35fr_0.75fr_1fr] bg-forest text-ivory sm:grid-cols-[1.5fr_0.8fr_1fr]" data-id="element-60" data-mp="3d8sz3uxpwyqd">
            <div className="p-4 text-xs font-semibold uppercase tracking-wide sm:p-5" data-id="element-61" data-mp="3i9qigaugrytg">Feature</div>
            <div className="p-4 text-center font-serif text-base sm:p-5 sm:text-lg" data-id="element-62" data-mp="3n7s0qtk2fu3v">Medufit</div>
            <div className="p-4 text-center text-[11px] font-medium leading-tight text-ivory/75 sm:p-5 sm:text-sm" data-id="element-63" data-mp="2pm4doz9i2o50">
              Multiple Supplements
            </div>
          </div>
          {COMPARE.map((row, index) => <div key={row.feature} className={`grid grid-cols-[1.35fr_0.75fr_1fr] items-center sm:grid-cols-[1.5fr_0.8fr_1fr] ${index % 2 === 0 ? 'bg-ivory/60' : 'bg-beige/35'}`} data-id="element-64" data-mp="2zgw8jvbp6ww3" data-mpi={index}>
              <div className="p-4 text-sm font-medium leading-snug text-forest sm:p-5" data-id="element-65" data-mp="2bs3czzyzmr20">{row.feature}</div>
              <div className="flex justify-center p-4 sm:p-5" data-id="element-66" data-mp="248aw7jygjmd6">
                <Cell value={row.medufit} data-id="element-67" data-mp="1z9zkf3olr1sb" />
              </div>
              <div className="flex justify-center p-4 sm:p-5" data-id="element-68" data-mp="1z8g1t6fh4end">
                <Cell value={row.others} data-id="element-69" data-mp="1ua4t4z0x0a6q" />
              </div>
            </div>)}
        </Reveal>
      </div>
    </Section>;
}